import { Component, Input, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { ILabels } from "libraries/interfaces/ILabels";
import { Yii } from "libraries/interfaces/Yii";
import { EStayPermissions } from "libraries/enums/e-stay-permissions";

@Component({
    selector: 'references',
    template: `
        <div class="references">
            <ng-container *ngTemplateOutlet="link ? withLink : withoutLink"></ng-container>

            <ng-template #withLink>
                <div *ngIf="code || host" class="code-host" (click)="openExternalLink(link)">
                    <span>
                        <btn *ngIf="code" [label]="code"
                             classList="no-spacing"
                             type="actionLink"></btn>
                        <span *ngIf="gdsStatus" [title]="labels.gdsStatus"> - {{gdsStatus}}</span>
                    </span>
                    <ng-container *permissionIf="permissions.SHARED_HOST_SHOW">
                        <span class="host" *ngIf="showHost && host">({{ host | hostAlias | async }})</span>
                    </ng-container>
                </div>
            </ng-template>

            <ng-template #withoutLink>
                <span>{{ code }}<span *ngIf="gdsStatus" [title]="labels.gdsStatus"> - {{gdsStatus}}</span></span>
                <span class="host" *ngIf="host">({{ host | hostAlias | async }})</span>
            </ng-template>
        </div>
    `,
    styles: [`
        .references {
            display: flex;
            flex-direction: column;
        }

        .code-host {
            display: inline-flex;
            flex-direction: column;
        }
    `]
})
export class ReferencesComponent {

    public readonly labels: ILabels = {
        gdsStatus: Yii.t('wui-shared-js', 'Statut GDS'),
    };

    @Input()
    public code: string;

    @Input()
    public gdsStatus?: string;

    @Input()
    public host: string;

    @Input()
    public link: string;

    @Input()
    public showCode: boolean = true;
    @Input()
    public showHost: boolean = true;

    constructor(
        @Inject(DOCUMENT) private readonly document: Document
    ) {
    }

    public openExternalLink(link: string): void {
        this.document.defaultView.open(link, '_blank');
    }

    public permissions: typeof EStayPermissions = EStayPermissions;
}
